/* eslint-disable no-restricted-globals */
import Vue from "vue";
import Vuetify from "vuetify";

Vue.use(Vuetify);

const getPrimary = () => {
  if (location.href.includes("brolly")) {
    return "#0a0b6c";
  }
  if (location.href.includes("relif")) {
    return "#15183A";
  }
  return "#004cdc";
};

const getSecondary = () => {
  if (location.href.includes("brolly")) {
    return "#0a0b6c";
  }
  if (location.href.includes("relif")) {
    return "#F9D00A";
  }
  return "#004cdc";
};

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: getPrimary(),
        accent: getSecondary(),
        white: "#FFFFFF",
        background: "#FAFAFA",
        success: "#388E3C",
      },
    },
  },
});
